module.exports = __webpack_public_path__ + "bab4d3bca9cc7c785ba1865e464d58e8.jpg";